import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { components } from "@entities/journal";
import {
  $journalApi,
  journalQueryOptions,
} from "@entities/journal/fetch/fetch-client.ts";
import { updateSectionTwoRecord } from "../api/update-section-two-record.ts";
import { mapSectionTwoRequest } from "./map-section-two-request";

interface IUseUpdateSectionTwoRecord {
  sectionTwoId: string;
  itemNoVersionId?: string;
}

type Response = components["schemas"]["SectionTwoItemUpdateResponse"];

interface IRequest {
  mainJournalId: string;
  section2Id: string;
  section2ListId: string;
  specialJournalName: string;
  specialJournalDate: string;
  journalKeepersList?: Array<any>;
  dateHandover?: string | null;
  signer: string;
  file?:
    | { file?: File | null | undefined; id?: string | null | undefined }
    | null
    | undefined;
}

export function useUpdateSectionTwoRecord({
  sectionTwoId,
  itemNoVersionId,
}: IUseUpdateSectionTwoRecord) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: itemNoVersionId
      ? (data: IRequest) => {
          return updateSectionTwoRecord({
            itemNoVersionId,
            updateSectionTwoRequest: mapSectionTwoRequest(data),
            file: data.file,
          });
        }
      : async () => {},
    onSuccess: async (data: Response) => {
      queryClient.invalidateQueries({
        queryKey: $journalApi.queryOptions(
          "get",
          "/api/v1/journals/section-two/{sectionTwoId}",
          { params: { path: { sectionTwoId } } },
        ).queryKey,
      });
      if (itemNoVersionId) {
        queryClient.setQueryData(
          journalQueryOptions(
            "get",
            "/api/v1/journals/section-two/items/{itemNoVersionId}",
            { params: { path: { itemNoVersionId } } },
          ).queryKey,
          data,
        );
      }
    },
  });
}
